import useRewardBaseActions from './useRewardBaseActions'

export default useRewardBaseActions
